import {
  PortalUserCreateRequest as BankPortalUserCreateRequest,
  PortalUserResponse,
  PortalUserCreateRequest,
  UserRole,
} from '@b7hio/api-lib/src/ops-portal';
import { FeatureDialog } from '@b7hio/core-lib/src';
import { superstructResolver, FormFriendly } from '@b7hio/core-lib/src/form';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UserForm } from '../UserForm';
import {
  BankUserValidation,
  CreateUserValidation,
} from '../UserForm/UserForm.validation';

interface CommonProps {
  readonly open?: boolean;
  readonly onClose: (event: object, reason: string) => void;
  readonly onSubmit: (values: PortalUserCreateRequest) => Promise<void>;
  readonly portal: 'banks' | 'ops';
  readonly partnerUid?: string;
}

type BankProps = {
  readonly onSubmit: (values: BankPortalUserCreateRequest) => Promise<void>;
  readonly portal: 'banks';
} & CommonProps;

type OpsProps = {
  readonly portal: 'ops';
} & CommonProps;

type Props = OpsProps | BankProps;

export const UserCreateDialog: React.FC<Props> = ({
  open,
  onClose,
  onSubmit,
  portal,
  partnerUid,
}) => {
  const { t } = useTranslation(['users']);
  const form = useForm<
    FormFriendly<PortalUserCreateRequest | PortalUserResponse>
  >({
    resolver: superstructResolver(
      portal === 'ops' ? CreateUserValidation : BankUserValidation,
      { coerce: true }
    ),
    defaultValues:
      portal === 'banks'
        ? {
            userType: 'BANK',
            userRoles: [UserRole.BANK_ADMIN],
            email: '',
            partnerUid,
            givenName: '',
            familyName: '',
          }
        : {
            userType: '',
            userRoles: [],
            email: '',
            partnerUid: '',
            givenName: '',
            familyName: '',
          },
  });

  return (
    <FeatureDialog
      id="UserCreateDialog"
      open={open}
      title={t('users:createUser')}
      onClose={onClose}>
      <FormProvider {...form}>
        <form
          style={{ gridArea: 'form' }}
          // eslint-disable-next-line no-console
          onSubmit={form.handleSubmit(onSubmit, (yeet) => console.log(yeet))}>
          <UserForm portal={portal} />
        </form>
      </FormProvider>
    </FeatureDialog>
  );
};
